import React from 'react';
import Navbar from '../components/Navbar'
import Hero from '../components/Hero.js'
import logoImage from '../../src/assets/logo.png';
import powederImage from '../../src/assets/powered in b2r6nnies.png'
import '../styles/Hero.css';

  export default function DesktopLayout() {

   return (
     <div className="desktop-layout hero-container" >
      <Navbar></Navbar>
       <div className="logo-container">
          <img src={logoImage} alt="Logo MegaHortz" className="logo" />
       </div>
       <Hero></Hero>
       <footer>
          <div className="logo-container">
            <img src={powederImage} alt="Powdered in Baronnies" className="logo" />
          </div>
       </footer>
      </div>
   );
}
